import React from "react";

function SvgIcMapPoi031(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M16 5.95a1 1 0 011 1v8c0 1.101-.9 2-2 2h-1V25a2 2 0 01-4 0v-8.05H9c-1.101 0-2-.899-2-2v-8a1 1 0 112 0v5a1 1 0 001 1c.552 0 1-.5 1-1v-5a1 1 0 112 0v5a1 1 0 102 0v-5a1 1 0 011-1zm5.014.05c.306 0 .592.073.852.194.737.314 1.313 1.004 1.414 1.804L24.987 17c.138 1.091-1.018 1.986-1.987 2v6c0 1.101-.876 2-1.986 2A2.013 2.013 0 0119 25V8c0-1.101.907-2 2.014-2z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi031;
